import API from './apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalLinks`,
  scopes: ExtHubRequest,
});

api.createEntities([
  //All purpose
  { name: 'GetLinkTypes' },
]);

//all purpose
const GetLinkTypes = () => api.endpoints.GetLinkTypes.post();

export { GetLinkTypes };
